// @ts-nocheck a4814b5c
import tweenEngine from '../../localTweenEngine/localTweenEngine';

/** core.animations.tweenEngineGreenSock */
const { engine } = tweenEngine;
/** core.animationsFactory */
const { factory } = tweenEngine;

/**
 * Position base animation object
 * @param {Array<HTMLElement>|HTMLElement} elements DOM elements
 * @param {Number} [duration=1.0]
 * @param {Number} [delay=0]
 * @param {Object} params
 * @returns {TweenMax}
 */
function baseColor(elements, duration, delay, params) {
  params.duration = duration || 0;
  params.delay = delay || 0;

  return engine.tween(elements, params, [
    'color',
    'backgroundColor',
    'backgroundPosition',
    'backgroundSize',
    'borderTopColor',
    /*not animatable:*/ 'backgroundImage',
    'backgroundRepeat',
  ]);
}

factory.registerAnimation('BaseColor', baseColor);
